import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Category {
  id: string;
  nome: string;
  descricao: string | null;
  ativo: boolean;
  nivel: number;
  ordem: number;
  categoria_pai_id: string | null;
  criado_em: string;
  atualizado_em: string;
  total_produtos: number;
  caminho_completo: string;
}

export const useCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      const { data, error } = await supabase
        .rpc("obter_subcategorias");

      if (error) {
        console.error("Erro ao buscar categorias:", error);
        throw error;
      }

      return data as Category[];
    },
  });
};

export const useSubcategories = (parentId?: string) => {
  return useQuery({
    queryKey: ["subcategories", parentId],
    queryFn: async () => {
      const { data, error } = await supabase
        .rpc("obter_subcategorias", { categoria_pai: parentId });

      if (error) {
        console.error("Erro ao buscar subcategorias:", error);
        throw error;
      }

      return data as Category[];
    },
  });
};